import { TypeOfContact } from "@app/modules/contact/contactConstants";
import { DataType } from "@app/models/constants";
import { CountryCode } from "@app/core/utilities/phones";

export interface CarrierContactRequest {
    contactType: TypeOfContact;
    /**  @deprecated  */
    language?: string;
    sortBy?: string;
    orderBy?: string;
}

export interface CarrierContactsResponse {
    contacts: ContactPersonInformation[];
}

export interface ContactPersonInformation {
    firstName: string;
    lastName: string;
    title?: string;
    department?: string;
    officeNumber?: string;
    officeExtension?: string;
    tollFreeNumber?: string;
    faxNumber?: string;
    email?: string;
    extendedAttributes?: ExtendedAttribute[];
    countryCode: CountryCode;
}

export const defaultContactConfig: ContactDefinition = {
    contactOrder: [
        "newBusinessBlock",
        "policyManagementBlock",
        "investmentsAndRetirementBlock",
        "contractsAndCommissionsBlock",
        "counselorServicesBlock",
        "claimingBlock",
    ],
};

interface ExtendedAttribute {
    code: string;
    value: string;
    dataType: DataType;
}
